import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const ShareOptionsModal = ({ referralLink, onClose }) => {
  const shareOnWhatsApp = () => {
    const message = `Join TaxSarthi using my referral link: ${referralLink}`;
    window.open(`https://wa.me/?text=${encodeURIComponent(message)}`, "_blank");
  };

  return (
    <div className="modal fade show" style={{ display: "block" }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Share Referral Code</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <p>Your referral link: {referralLink}</p>
            <div className="d-flex gap-2">
              <button className="btn btn-success" onClick={shareOnWhatsApp}>
                Share via WhatsApp
              </button>
              <button 
                className="btn btn-secondary" 
                onClick={() => navigator.clipboard.writeText(referralLink)}
              >
                Copy Link
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShareOptionsModal;